function printInConsole() {
  const env = process.env.NEXT_PUBLIC_ENVIRONMENT;
  if (env === "DEVELOPMENT" || env === "UAT" || env === "LOCAL") console.log(...arguments);
}

export { printInConsole };
